import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-porte-empresa-form-control',
    templateUrl: './porte-empresa-form-control.component.html',
    styleUrls: ['./porte-empresa-form-control.component.less']
})
export class PorteEmpresaFormControlComponent {
    @Input() label = 'Porte Empresa';
    @Input() helpText = 'Código e descrição do porte da empresa';
    @Input() codigo: number = null;
    @Input() nome: string = null;
}
